import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe } from "lucide-react";
import { Logo } from "./Logo";
import { BrandText } from "./Brand";
import { NAV_LINKS, SERVICES, CONTACT_INFO } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { lang, t, resetLang } = useLang();

  return (
    <footer
      data-testid="footer"
      className="bg-deepblack border-t border-gold/15 pt-20 pb-8"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <Logo />
          <p className="mt-5 text-sm text-muted2 leading-relaxed max-w-xs">
            {t.footer.brand}
          </p>
        </div>

        <div>
          <h4 className="font-serif text-xl text-offwhite mb-5">{t.footer.services}</h4>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.title.en}>
                <Link
                  to="/services"
                  className="text-sm text-muted2 hover:text-gold transition-colors"
                >
                  {s.title[lang]}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-xl text-offwhite mb-5">{t.footer.company}</h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className="text-sm text-muted2 hover:text-gold transition-colors"
                >
                  {l.label[lang]}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/hipaa"
                className="text-sm text-muted2 hover:text-gold transition-colors"
              >
                {t.footer.hipaa}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-xl text-offwhite mb-5">{t.footer.contact}</h4>
          <ul className="space-y-4 text-sm text-muted2">
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-gold shrink-0" />
              {CONTACT_INFO.phone}
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-gold shrink-0" />
              {CONTACT_INFO.email}
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-gold shrink-0 mt-0.5" />
              {CONTACT_INFO.coverage[lang]}
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mt-16 pt-8 border-t border-gold/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-muted2">
          © {new Date().getFullYear()} <BrandText>MedPrime</BrandText>. {t.footer.rights}
        </p>
        <div className="flex items-center gap-6 text-xs text-muted2">
          <button
            onClick={resetLang}
            data-testid="footer-change-language"
            className="inline-flex items-center gap-1.5 hover:text-gold transition-colors"
          >
            <Globe size={13} /> {t.footer.changeLang}
          </button>
          <span className="hover:text-gold transition-colors cursor-pointer">{t.footer.privacy}</span>
          <Link to="/hipaa" className="hover:text-gold transition-colors">{t.footer.hipaaNotice}</Link>
          <span className="hover:text-gold transition-colors cursor-pointer">{t.footer.terms}</span>
        </div>
      </div>
    </footer>
  );
}
